document.addEventListener('DOMContentLoaded', () => {
  const variantLabels = document.querySelectorAll('label[data-tooltip]');
  if (variantLabels.length === 0) return;

  const tooltipElement = document.createElement('div');
  tooltipElement.classList.add('variant-tooltip');
  document.body.appendChild(tooltipElement);

  let tooltipTimeout;

  variantLabels.forEach(label => {
    label.addEventListener('mouseenter', (event) => {
      const target = event.currentTarget;
      const tooltipText = target.getAttribute('data-tooltip');

      tooltipElement.textContent = tooltipText;

      const labelRect = target.getBoundingClientRect();
      const tooltipRect = tooltipElement.getBoundingClientRect();

      const top = labelRect.top + window.scrollY - tooltipRect.height - 8; 
      const left = labelRect.left + window.scrollX + (labelRect.width / 2) - (tooltipRect.width / 2);

      tooltipElement.style.top = `${top}px`;
      tooltipElement.style.left = `${left}px`;

      tooltipTimeout = setTimeout(() => {
        tooltipElement.classList.add('is-visible');
      }, 800); 
    });

    label.addEventListener('mouseleave', () => {
      clearTimeout(tooltipTimeout);
      tooltipElement.classList.remove('is-visible');
    });
  });
});